var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    ref: "modal",
    attrs: {
      "title": "刪除週期性預約",
      "ok-title": "確認刪除",
      "ok-variant": "danger",
      "cancel-title": "取消",
      "ok-disabled": _vm.loading,
      "cancel-disabled": _vm.loading,
      "no-close-on-backdrop": _vm.loading,
      "no-close-on-esc": _vm.loading
    },
    on: {
      "hidden": _vm.handleCancel,
      "ok": _vm.handleConfirm
    }
  }, [_c('p', {
    staticClass: "mb-3"
  }, [_vm._v(" 請選擇刪除範圍： ")]), _c('b-form-group', [_c('b-form-radio-group', {
    attrs: {
      "stacked": ""
    },
    model: {
      value: _vm.scope,
      callback: function callback($$v) {
        _vm.scope = $$v;
      },
      expression: "scope"
    }
  }, [_c('label', {
    staticClass: "mutation-scope"
  }, [_c('b-form-radio', {
    attrs: {
      "value": "this"
    }
  }, [_c('div', [_c('strong', [_vm._v("這次預約")]), _c('p', {
    staticClass: "mutation-scope__note"
  }, [_vm._v("只修改選定日期的預約")])])])], 1), _c('label', {
    staticClass: "mutation-scope"
  }, [_c('b-form-radio', {
    attrs: {
      "value": "future"
    }
  }, [_c('div', [_c('strong', [_vm._v("這次預約與後續預約")]), _c('p', {
    staticClass: "mutation-scope__note"
  }, [_vm._v("修改選定日期及之後的所有預約")])])])], 1), _c('label', {
    staticClass: "mutation-scope"
  }, [_c('b-form-radio', {
    attrs: {
      "value": "all"
    }
  }, [_c('div', [_c('strong', [_vm._v("所有預約")]), _c('p', {
    staticClass: "mutation-scope__note"
  }, [_vm._v("修改此週期性預約所有尚未開始的預約記錄")])])])], 1)])], 1), _vm.previewDates.length ? _c('div', {
    staticClass: "mt-3"
  }, [_c('h6', [_vm._v("將被刪除的預約：")]), _c('ul', {
    staticClass: "list-unstyled preview-list"
  }, _vm._l(_vm.previewDates, function (dateRange, index) {
    return _c('li', {
      key: index,
      staticClass: "mb-2"
    }, [_c('i', {
      staticClass: "fa fa-calendar text-danger"
    }), dateRange.end ? _c('span', [_vm._v(" " + _vm._s(_vm.formatDate(dateRange.start)) + " ~ " + _vm._s(_vm.formatDate(dateRange.end)) + " ")]) : _c('span', [_vm._v(" " + _vm._s(_vm.formatDate(dateRange.start)) + " ")])]);
  }), 0), _vm.previewDates.length >= 5 ? _c('p', {
    staticClass: "text-muted small"
  }, [_vm._v(" * 僅顯示前 5 筆預約 ")]) : _vm._e()]) : _vm._e(), _vm.loading ? _c('div', {
    staticClass: "text-center mt-3"
  }, [_c('b-spinner', {
    attrs: {
      "small": ""
    }
  }), _c('span', {
    staticClass: "ml-2"
  }, [_vm._v("處理中...")])], 1) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }